import { createContext, useContext } from 'react';

export type EditorStageView = 'preview' | 'editor';

export function isCanvasEditorStage(
  showCanvasToggle: boolean,
  stageView: EditorStageView,
): boolean {
  return showCanvasToggle && stageView === 'editor';
}

export type EditorStageViewContextValue = {
  stageView: EditorStageView;
  isEditorStage: boolean;
  showCanvasToggle: boolean;
  setStageView: (view: EditorStageView) => void;
};

const EditorStageViewContext = createContext<EditorStageViewContextValue>({
  stageView: 'preview',
  isEditorStage: false,
  showCanvasToggle: false,
  setStageView: () => undefined,
});

EditorStageViewContext.displayName = 'EditorStageViewContext';

export const EditorStageViewProvider = EditorStageViewContext.Provider;

export function useEditorStageView(): EditorStageViewContextValue {
  return useContext(EditorStageViewContext);
}
